











































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import {
  updateBabysitterProfile,
  languagesPayload,
} from '@/interfaces/Payload';
import LanguagePicker from '@/components/dashboard/shared/components/LanguagePicker.vue';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {
    LanguagePicker,
  },
})
export default class BabysitterProfile extends Vue {
  @Prop()
  id!: number;

  public user: any = {};
  public babysitter: any = {};
  public address: any = {};
  public experience: number[] = [];

  public selectedLanguages: any = [];

  public dateMenu: boolean = false;
  public languages: any = [];
  public experiences: number[] = [];

  public levels: any[] = [
    {
      id: 2,
      name: 'Advance',
    },
    {
      id: 3,
      name: 'Intermediate',
    },
    {
      id: 4,
      name: 'Basic',
    },
  ];

  public dataLoading: boolean = true;

  public $refs!: {
    picker: any;
    dateMenu: any;
  };

  public setPayload(babysitter: any) {
    this.user = {
      first_name: babysitter.first_name,
      last_name: babysitter.last_name,
    };

    this.babysitter = {
      contact: babysitter.contact,
      date_of_birth: babysitter.date_of_birth,
      bank_account: babysitter.bank_account,
      training_passed: babysitter.training_passed,
      driving_license: babysitter.driving_license,
      active_driver: babysitter.active_driver,
      smoker: babysitter.smoker,
      animator: babysitter.animator,
      covid_vaccinated: babysitter.covid_vaccinated,
    };

    this.address = {
      address: babysitter.address.address,
      area_name: babysitter.address.area_name,
      city_id: babysitter.address.city_id,
    };

    if (babysitter.nativeLanguage) {
      babysitter.languages.push(babysitter.nativeLanguage);
    }

    this.experience = babysitter.experience.map((exp: any) => exp.id);
  }

  public getPayload(): updateBabysitterProfile {
    return {
      user: this.user,
      babysitter: this.babysitter,
      address: this.address,
      experience: this.experience,
      languages: {
        ...this.selectedLanguages,
      },
    };
  }

  public async save() {
    let payload: updateBabysitterProfile = this.getPayload();

    this.dataLoading = true;

    let response = await axios.post(api.path('v1.b.profile'), payload);

    this.$toast.success(response.data.message);

    await this.fetchUser();

    this.dataLoading = false;
  }

  @Action('auth/fetchUser') fetchUser: any;

  public async loadLanguages() {
    let params = {
      paginate: 'no',
    };

    await axios
      .get(api.path('v1.admin.languages'), { params: params })
      .then((res) => (this.languages = res.data.data));
  }

  public async loadExperiences() {
    let params = {
      paginate: 'no',
      order_sort: 'asc',
    };

    await axios
      .get(api.path('v1.experiences'), { params: params })
      .then((res) => (this.experiences = res.data.data));
  }

  public async loadBabysitter() {
    let res = await axios.get(api.path('v1.b.profile.edit'));

    this.setPayload(res.data.data);
  }

  @Watch('dateMenu')
  onValueChange(value: any) {
    value && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
  }

  public setDateOfBirth(date: any) {
    this.$refs.dateMenu.save(date);
  }

  public customTextName(item: any): string {
    return `${item.name} - ${item.level.name}`;
  }

  public async created() {
    await this.loadBabysitter();
  }

  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  public async mounted() {
    await this.fetchCities();
    await this.loadExperiences();

    this.dataLoading = false;
  }
}
